import { IconButton, Tooltip } from '@mui/material';
import { MouseEventHandler } from 'react';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

type Props = { onClick: MouseEventHandler };

export const AddThreadAction = ({ onClick }: Props) => {
  const { translate } = useLocales();
  return (
    <Tooltip title={translate('shared.tooltip.add_thread')}>
      <IconButton
        size="small"
        style={{ transform: 'scaleX(-1)' }}
        onClick={onClick}
      >
        <Iconify icon="tabler:timeline-event-text" />
      </IconButton>
    </Tooltip>
  );
};
